module.exports = __webpack_public_path__ + "img/dropdown-white.9a750dd3.svg";